import { useCallback, useEffect, useMemo } from 'react';
import { useAuthStore, useEditModeStore } from '../store/authStore';
import { useCheckBeforeMove } from './useCheckBeforeMove';

/**
 * Edit Mode 관리 훅
 * 
 * 일반 페이지와 onboard_preview 페이지에서 다른 동작을 수행합니다:
 * - 일반 페이지: user가 로그인되어 있어야만 edit mode 활성화 가능
 * - onboard_preview: 로그인 전 단계이므로 user 체크 없이 edit mode 사용 가능
 */
export const useEditMode = () => {
  const user = useAuthStore((state) => state.user);
  const isEditMode = useEditModeStore((state) => state.isEditMode);
  const setIsEditMode = useEditModeStore((state) => state.setIsEditMode);

  const { getCurrentPage } = useCheckBeforeMove();
  const { page } = getCurrentPage();

  const effectiveIsEditMode = useMemo(() => {
    if (page === 'onboard') {
      return isEditMode;
    }
    return isEditMode && (user != null);
  }, [isEditMode, user, page]);

  const setEditMode = useCallback((value: boolean) => {
    if (page === 'onboard') {
      setIsEditMode(value);
      return;
    }
    if (value && !user) {
      console.warn("Cannot enter edit mode when not logged in");
      return;
    }

    setIsEditMode(value);
  }, [user, setIsEditMode, page]);

  return {
    isEditMode: effectiveIsEditMode,
    setEditMode,
  };
};